class RouteDetailsLineItemsRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteDetailsLineItem";

    super(entityName);

    const options = Monet.Grid.Utils.paginationOptions;

    if (!App.Forms[this.entityName]) {
      App.Forms[this.entityName] = {
        layout: {},
        dataMapper: null,
        pagination: {
          first: options.FIRST,
          max: options.MAX_RESULT,
          blocked: false,
          canIncrement: true
        },
        columnToOrders: [],
        ordersIds: []
      };
    }

    if (!App.Objects[this.entityName]) {
      App.Objects[this.entityName] = this;
    }
  }

  getFieldsToGridLayout = callback => {
    
    try {
      const ajax = new Monet.Ajax();
      const url = `form/${this.entityName}/index`;

      ajax.url = url;
      ajax.success = data => {
        if (data) {
          App.Forms[this.entityName].layout["index"] = data;
        }
        if (callback) {
          callback();
        }
      };

      ajax.error = function(response) {
        Monet.Configurations.errorNotification(null, response);
      };

      ajax.send();
    } catch (e) {
      new Monet.Exception.ReturnError(
        this,
        "Error on get grid layout on route monitoring route"
      ).console();
    }
  };

  updateGrid = (filter, callback, appendCollection) => {
    try {
      const dataProvider = App.Forms[this.entityName].dataProvider;
      const grid = App.Forms[this.entityName].table;

      if (filter.criteriaChain.length) {
        const columns = grid.getColumns();

        const lineItemsCollection = new App.Collections.LineItems();
        const projectionBuilder = new Monet.Builder.Projection();

        projectionBuilder.setLayout(
          JSON.parse(
            JSON.stringify(App.Forms[this.entityName].layout.index)
          )
        );
        projectionBuilder.parseLayout();

        const hasNumber = projectionBuilder.projection.fields.find(field => field.name === 'order');
        if(!hasNumber) {
          projectionBuilder.addField({name: 'number'})
        }
        
        projectionBuilder.addField({name: 'lineItemID'})

        projectionBuilder.projection.fields = projectionBuilder.projection.fields.map(
          field => {
            if (field.name !== "order" && field.name !== "number") {
              field.name = "lineItems." + field.name;
            } else {
              // na projeção esse campo não pode ter comportamento de lookup.
              field.name = "number";
              field.type = "TEXT";
              field.lookupEntityColumn = "";
            }
            return field;
          }
        );

        dataProvider.arrayIds = [];

        if (appendCollection) {
          lineItemsCollection.reset();
        }

        const loading = new Monet.UI.LoadingData();
        loading.init();
        loading.show();

        lineItemsCollection.filterWithRestrictionsByHaveToMany({
          entityParentToUrl: "Order",
          attributeHasMany: "lineItems",
          attributeParent: "order",
          filter,
          criteria: projectionBuilder.projection.toString(),
          success: result => {
            if (callback) {
              callback(this.entityName, columns, result, false);
            }
            loading.hide();
          }
        });
      } else {
        dataProvider.setData([]);
        grid.invalidate();
        Monet.Grid.Utils.hideGridNoResult(this.entityName);
        Monet.Grid.Utils.showGridNoResult(this.entityName);
      }
    } catch (e) {
      new Monet.Exception.ReturnError(
        this,
        "Error on update route monitoring route",
        e
      ).console();
    }
  };

  getFilter = (stopId) => {
    const filter = {
      criteriaChain: [],
      sort: []
    };

    const columnToOrders = App.Forms[this.entityName].columnToOrders || [];
    const _filter = App.Forms[this.entityName].filterBuilder;

    if (_filter) {
      const criteriaByFilterBuilder = _filter.getCriteriaChain();
      filter.criteriaChain = criteriaByFilterBuilder.criteriaChain;

      for (let index in filter.criteriaChain) {
        const criteria = filter.criteriaChain[index];

        for (let key in criteria) {
          const chain = criteria[key];
          
          for (let i in chain) {
            let value = chain[i].attr;
            value = 'lineItems.' + value;
            chain[i].attr = value;
          }
        }
      }
    }

    filter.criteriaChain[0]?.and.push({
      attr: "stop.id",
      eq: stopId
    });

    columnToOrders.forEach(item => {
      const field =
        item.field === "order.number"
          ? item.field.replace("order.", "")
          : `lineItems.${item.field}`;
      filter.sort.push({
        attr: field,
        type: item.order
      });
    });

    return filter;
  };
}

App.Routers.RouteDetailsLineItem = RouteDetailsLineItemsRouter;
